import { action, makeObservable, observable } from 'mobx'

import { GlossarySection } from '@new/__global/components/GlossarySidebar'

class GlossaryStoreClass {
  // ------------ Observables
  isOpen = observable.box(false)
  searchTerm = observable.box('')
  highlightTarget = observable.box('')

  domain = ''
  sections: GlossarySection[] = []

  // -------- actions
  setIsOpen = (value: boolean) => {
    this.isOpen.set(value)
  }

  openGlossary = () => {
    this.isOpen.set(true)
  }

  closeGlossary = () => {
    this.isOpen.set(false)
    this.searchTerm.set('')
    this.highlightTarget.set('')
  }

  toggleGlossary = () => {
    this.isOpen.set(!this.isOpen.get())
  }

  setGlossaryContent = (domain: string, sections: GlossarySection[]) => {
    this.domain = domain
    this.sections = sections
  }

  openGlossaryWithContent = (domain: string, sections: GlossarySection[]) => {
    this.setGlossaryContent(domain, sections)
    this.openGlossary()
  }

  openGlossaryWithHighlight = (
    domain: string,
    sections: GlossarySection[],
    highlightTarget: string,
  ) => {
    this.setGlossaryContent(domain, sections)
    this.highlightTarget.set(highlightTarget)
    this.searchTerm.set('')
    this.openGlossary()
  }

  clearSearch = () => {
    this.searchTerm.set('')
  }

  clearHighlight = () => {
    this.highlightTarget.set('')
  }

  constructor() {
    makeObservable(this, {
      domain: observable,
      sections: observable,
      openGlossary: action.bound,
      closeGlossary: action.bound,
      toggleGlossary: action.bound,
      setGlossaryContent: action.bound,
      openGlossaryWithContent: action.bound,
      openGlossaryWithHighlight: action.bound,
      clearSearch: action.bound,
      clearHighlight: action.bound,
    })
  }
}

export const GlossaryStore = new GlossaryStoreClass()
